import * as React from 'react';
import styled from 'styled-components';
import THEME from '../../theme';
const Result = (props) => {
    const { heading, subheading, small, tags, progressBar, supplementary } = props.result;
    return (React.createElement(ResultStyled, { onMouseDown: () => {
            props.onMouseDown(props.result, props.index);
        }, className: props.active ? 'active' : '' },
        React.createElement("h3", null,
            heading,
            ' ',
            tags &&
                tags.length > 0 &&
                tags.map((tag) => (React.createElement("div", { className: "label", style: {
                        backgroundColor: tag.backgroundColor,
                        color: tag.color,
                    } }, tag.label))),
            React.createElement("span", null, small)),
        React.createElement("p", null, subheading),
        progressBar && (React.createElement("p", null,
            progressBar.displayFrom,
            React.createElement("span", { className: "t-fr" }, progressBar.displayTo))),
        progressBar && (React.createElement("div", { className: "progressbar" },
            React.createElement("div", { className: "progress", style: {
                    width: `${(progressBar.partAmount / progressBar.amount) * 100}%`,
                } }))),
        React.createElement("div", { className: "supplementary" }, supplementary &&
            supplementary.map((s, i) => (React.createElement("div", { key: i },
                React.createElement("h3", null,
                    s.header,
                    React.createElement("small", null, s.small))))))));
};
export default Result;
const ResultStyled = styled.div `
  padding: 10px;
  display: block;
  border-bottom: 1px solid lightgrey;
  text-decoration: none;
  cursor: pointer;
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;

  &.active,
  &:hover {
    background: lightgrey;
  }

  .supplementary {
    padding-top: 5px;
    font-size: 0.8em;

    small {
      float: right;
    }
  }

  h3 {
    font-size: 0.85em;
    margin: 0;
    & > span {
      float: right;
      font-size: 0.9em;
    }
    .label {
      font-size: 0.5em;
      border-radius: 2px;
      background-color: lightgrey;
      color: ${THEME.COLOR_SECONDARY};
      display: inline-block;
      padding: 0.2em 0.4em;
      vertical-align: middle;
    }
  }
  p {
    margin: 2px 0;
    color: grey;
    font-size: 0.7em;
  }

  .t-fr {
    float: right;
  }

  overflow: hidden;

  .progressbar {
    border-radius: 1px;
    overflow: hidden;
    border: 1px solid ${THEME.COLOR_PRIMARY};
    opacity: 0.5;

    .progress {
      height: 2px;
      background-color: ${THEME.COLOR_PRIMARY};
    }
  }
`;
//# sourceMappingURL=Result.js.map